import type { ReactNode } from 'react';

export const symbol_translate_indic: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M247-340q-56 0-98.5-28T77-444q-7-11-2.5-22.5T90-484q11-5 23-1.5t19 14.5q20 32 48.5 51.5T247-400q46 0 74.5-26.5T350-491q0-37-26-63t-64-26h-20q-13 0-21.5-8.5T210-610q0-13 8.5-21.5T240-640h20q29 0 49.5-21t20.5-53q0-26-16.5-46T265-780q-17 0-31.5 7T207-755q-12 11-24.5 10t-20.5-9q-8-8-9.5-18.5T160-792q21-20 47-34t60-14q57 0 90 37.5t33 88.5q0 31-14 55.5T332-616q20 12 34 26t24 30h140v-220h-50q-13 0-21.5-8.5T450-810q0-13 8.5-21.5T480-840h160q13 0 21.5 8.5T670-810q0 13-8.5 21.5T640-780h-50v235l-18 45H410v12q0 61-45.5 104.5T247-340Zm337 143-38 98q-3 8-10.5 13.5T519-80q-16 0-25-13t-3-28l160-415q4-11 13.5-17.5T685-560h29q11 0 20.5 6.5T748-536l160 415q6 15-3 28t-25 13q-10 0-17.5-5.5T852-100l-38-97H584Zm21-55h188l-94-248-94 248Z"
		/>
	</svg>
);
